import { useTranslation } from "react-i18next";
import React from 'react';
import {Col, Empty, Row, Select, Spin} from "antd";
import StatisticalReportCard from '../../StatisticalReportCard';
import TableWithTotals from '../../../../../../components/table-with-totals/TableWithTotals';
import {handleExportReport} from "../../../../../../utils/staticReport";
import {
  exportTableUniversityRateUnitByCourse,
  exportTableUniversityRateUnitByModule,
  exportTableUniversityRateUnitBySequence,
  exportTableUniversityUnitDiscussByTime,
  exportTableUniversityUnitDiscussCourseAction,
  exportTableUniversityUnitReviewAccess
} from "../../../../../../service/statistical-report";
import dayjs from "dayjs";
import {createTableData, rateTransformData} from "../../../../for-instructors/components/table/tableConvertData";
import {BarStackedChartProps, DualChart} from "../../../../../../types/static-report";
import {staticReportStore} from "../../../../../../stores/stores";

type FeedbackEvaluationTableProps = {
  loading: boolean,
  unitDiscussUniversityList: BarStackedChartProps[];
  courseDiscussActionUniversity: BarStackedChartProps[];
  unitReviewAccessUniversity: DualChart[];
  rateUnitByModuleUniversity: BarStackedChartProps[];
  rateCourseByModuleUniversity: BarStackedChartProps[];
  rateSequenceByModuleUniversity: BarStackedChartProps[];
  setModuleGroup: (value: any) => void,
}


const FeedbackEvaluationTable = ({
                                   loading,
                                   unitDiscussUniversityList,
                                   courseDiscussActionUniversity,
                                   unitReviewAccessUniversity,
                                   rateUnitByModuleUniversity,
                                   rateCourseByModuleUniversity,
                                   rateSequenceByModuleUniversity,
                                   setModuleGroup
                                 }: FeedbackEvaluationTableProps) => {

  const { t } = useTranslation();
  const {filterValues} = staticReportStore()

  const exportPayload = {
    from: dayjs(filterValues.dateFrom).toISOString(),
    to: dayjs(filterValues.dateTo).toISOString(),
    courseLevelIds: filterValues?.courseLevelIds,
    industryGroupIds: filterValues?.industryGroupIds,
    courseIds: filterValues?.courseIds,
    timeUnit: filterValues.timeUnit,
    courseStructureType: filterValues?.courseStructureType,
    teacherIds: filterValues?.lecturerIds,
    universityId: filterValues?.universityIds,
    moduleGroup: filterValues?.moduleGroup,
  };


  return <>
    <section className="section-table--chart">
      <div className="table-chart--label">
        <p className="text">{t("Thống kê số lượng phản hồi", "Thống kê số lượng phản hồi")}</p>
      </div>
      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}}>
        <Col sm={{span: 12}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Thống kê số lượng phản hồi theo thời gian", "Thống kê số lượng phản hồi theo thời gian")}
            content={
              <Spin spinning={loading}>
                {unitDiscussUniversityList.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={createTableData(unitDiscussUniversityList).dataSource}
                    columns={[
                      {
                        title: t("Thời gian tạo", "Thời gian tạo"),
                        dataIndex: "name",
                        key: "name",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                      },
                      ...createTableData(unitDiscussUniversityList, 'right').columns,
                      {
                        title: t("Tổng", "Tổng"),
                        dataIndex: "total",
                        key: "total",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                        align: 'right'
                      },
                    ]}
                    keyColumn="criteria"
                    // height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityUnitDiscussByTime, t("Thống kê số lượng phản hồi theo thời gian", "Thống kê số lượng phản hồi theo thời gian"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityUnitDiscussByTime, t("Thống kê số lượng phản hồi theo thời gian", "Thống kê số lượng phản hồi theo thời gian"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Thống kê số lượng phản hồi theo bài giảng", "Thống kê số lượng phản hồi theo bài giảng")}
            content={
              <Spin spinning={loading}>
                {courseDiscussActionUniversity.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={createTableData(courseDiscussActionUniversity).dataSource}
                    columns={[
                      {
                        title: t("Bài giảng", "Bài giảng"),
                        dataIndex: "name",
                        key: "name",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                      },
                      ...createTableData(unitDiscussUniversityList, 'right').columns,
                      {
                        title: t("Tổng", "Tổng"),
                        dataIndex: "total",
                        key: "total",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                        align: 'right'
                      },
                    ]}
                    keyColumn="criteria"
                    // height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }

            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityUnitDiscussCourseAction, t("Thống kê số lượng phản hồi theo bài giảng", "Thống kê số lượng phản hồi theo bài giảng"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityUnitDiscussCourseAction, t("Thống kê số lượng phản hồi theo bài giảng", "Thống kê số lượng phản hồi theo bài giảng"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
      </Row>
    </section>
    <section className="section-table--chart">
      <div className="table-chart--label">
        <p className="text">{t("Thống kê số lượng đánh giá", "Thống kê số lượng đánh giá")}</p>
      </div>
      <Row gutter={[{xs: 8, sm: 8, md: 16, lg: 16}, {xs: 8, sm: 8, md: 16, lg: 16}]}>
        <Col sm={{span: 12}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng đánh giá theo thời gian", "Số lượng đánh giá theo thời gian")}
            content={
              <Spin spinning={loading}>
                {unitReviewAccessUniversity.length > 0 ? (
                  <TableWithTotals
                    hasTotal={false}
                    data={unitReviewAccessUniversity}
                    columns={[
                      {
                        title: t("Ngày đánh giá", "Ngày đánh giá"),
                        dataIndex: "criteria",
                        key: "criteria",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                      },
                      {
                        title: t("Số lượt hoàn thành", "Số lượt hoàn thành"),
                        dataIndex: "lineValue",
                        key: "lineValue",
                        align: 'right'
                      },
                      {
                        title: t("Số lượt đánh giá", "Số lượt đánh giá"),
                        dataIndex: "columnValue",
                        key: "columnValue",
                        align: 'right'
                      },
                    ]}
                    keyColumn="criteria"
                    // height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            moreOption={
              <Select
                className="mr-2"
                defaultValue={3}
                style={{minWidth: 160}}
                onSelect={(value) => {
                  setModuleGroup(value);
                }}
                options={[
                  {value: 3, label: t("Bài kiểm tra", "Bài kiểm tra")},
                  {value: 2, label: t("Tài liệu tham khảo", "Tài liệu tham khảo")},
                  {value: 1, label: t("Đa phương tiện", "Đa phương tiện")},
                  {value: 4, label: 'SCORM & xAPI'},
                ]}
              />
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityUnitReviewAccess, t("Số lượng đánh giá theo thời gian", "Số lượng đánh giá theo thời gian"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityUnitReviewAccess, t("Số lượng đánh giá theo thời gian", "Số lượng đánh giá theo thời gian"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Tỷ lệ đánh giá khóa học", "Tỷ lệ đánh giá khóa học")}
            content={
              <Spin spinning={loading}>

                {rateCourseByModuleUniversity.length > 0 ? (
                  <TableWithTotals
                    hasTotal={false}
                    data={rateTransformData(rateCourseByModuleUniversity)}
                    columns={[
                      {
                        title: t("Khóa học", "Khóa học"),
                        dataIndex: "content",
                        key: "content",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                      },
                      ...createTableData(rateCourseByModuleUniversity, 'right').columns,
                    ]}
                    keyColumn="criteria"
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityRateUnitByCourse, t("Tỷ lệ đánh giá khóa học", "Tỷ lệ đánh giá khóa học"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityRateUnitByCourse, t("Tỷ lệ đánh giá khóa học", "Tỷ lệ đánh giá khóa học"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Tỷ lệ đánh giá bài giảng", "Tỷ lệ đánh giá bài giảng")}
            content={
              <Spin spinning={loading}>
                {rateSequenceByModuleUniversity.length > 0 ? (
                  <TableWithTotals
                    hasTotal={false}
                    data={rateTransformData(rateSequenceByModuleUniversity)}
                    columns={[
                      {
                        title: t("Bài giảng", "Bài giảng"),
                        dataIndex: "content",
                        key: "content",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                      },
                      ...createTableData(rateSequenceByModuleUniversity, 'right').columns,
                    ]}
                    keyColumn="criteria"
                    // height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityRateUnitBySequence, t("Tỷ lệ đánh giá bài giảng", "Tỷ lệ đánh giá bài giảng"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityRateUnitBySequence, t("Tỷ lệ đánh giá bài giảng", "Tỷ lệ đánh giá bài giảng"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Tỷ lệ đánh giá học liệu", "Tỷ lệ đánh giá học liệu")}
            content={
              <Spin spinning={loading}>

                {rateUnitByModuleUniversity.length > 0 ? (
                  <TableWithTotals
                    hasTotal={false}
                    data={rateTransformData(rateUnitByModuleUniversity)}
                    columns={[
                      {
                        title: t("Học liệu", "Học liệu"),
                        dataIndex: "content",
                        key: "content",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                      },
                      ...createTableData(rateUnitByModuleUniversity, 'right').columns,
                    ]}
                    keyColumn="criteria"
                    // height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityRateUnitByModule, t("Tỷ lệ đánh giá học liệu", "Tỷ lệ đánh giá học liệu"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityRateUnitByModule, t("Tỷ lệ đánh giá học liệu", "Tỷ lệ đánh giá học liệu"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />

        </Col>
      </Row>
    </section>
  </>;
};

export default FeedbackEvaluationTable;
